/* Western Era — "Please select a size" add-to-cart guard (rewritten 15 Aug 2026)
   Blocks Add to Cart on product pages until a size/variant is chosen, and shows
   the friendly inline error instead of Shopify's raw "Cannot find variant".

   Why it is written this way (Broadcast theme specifics):
   1. The variant option inputs and the hidden input[name="id"] are NOT inside
      the <form> element — they are associated to it via the form="…" attribute.
      Any lookup must therefore search by [form="<form id>"], not by nesting.
   2. The form contains elements named "id", and named form controls SHADOW form
      properties in the DOM — `form.id` returns an element, not the id string.
      Always use form.getAttribute('id').
   3. The guard runs on click in the CAPTURE phase, so it fires BEFORE the
      theme's own add-to-cart listener and can genuinely stop an empty submit.
      (The previous version listened to theme:cart:add, which runs after the
      theme's handler — the error flashed but the bad request still went out.) */
(() => {
  const errorText = 'Please select a size';

  const findErrorEl = (node) => {
    const section = node.closest('[data-section-type="product"]');
    return (section || document).querySelector('[data-variant-error]');
  };

  const idInputFor = (form) => {
    const formId = form.getAttribute('id');
    if (formId) {
      const associated = document.querySelector('input[name="id"][form="' + formId + '"]');
      if (associated) return associated;
    }
    return form.querySelector('input[name="id"]');
  };

  const showError = (errorEl) => {
    if (!errorEl) return;
    errorEl.textContent = errorText;
    errorEl.hidden = false;
    errorEl.classList.add('is-visible');
    if (typeof errorEl.scrollIntoView === 'function') {
      const rect = errorEl.getBoundingClientRect();
      if (rect.top < 0 || rect.bottom > window.innerHeight) {
        errorEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }
  };

  const hideError = (errorEl) => {
    if (!errorEl) return;
    errorEl.hidden = true;
    errorEl.classList.remove('is-visible');
  };

  const hideAllErrors = () => {
    document.querySelectorAll('[data-variant-error]').forEach(hideError);
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target && event.target.closest && event.target.closest('[data-add-to-cart]');
      if (!button) return;
      if (button.closest('[data-quick-add-modal]') || button.closest('[data-quick-add-holder]')) return;

      const form = button.closest('form[data-product-form]');
      if (!form) return;

      const idInput = idInputFor(form);
      if (idInput && idInput.value) {
        hideError(findErrorEl(button));
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      showError(findErrorEl(button));
    },
    true
  );

  document.addEventListener('theme:variant:change', (event) => {
    if (event.detail && event.detail.variant) hideAllErrors();
  });

  document.addEventListener('change', (event) => {
    const t = event.target;
    if (t && t.matches && t.matches('[data-single-option-selector]')) hideAllErrors();
  });
})();
